import {BaseModel} from "./Base";
import {TaskUser} from "./TaskUsers";

type UserDays = {
  [key: string]: Object;
};

type Users = {
  [key: string]: UserDays;
};

    export class TaskScheduleModel extends BaseModel  {
        dossierKey: string = "";
      taskKey: string = "";
      userKey: string = "";
      users: Users = {};
      startDay: {} = null;
      endDay: {} = null;
      duration: number =  0;
      
        constructor(data = null) {
            super();
            if(data) {
                this.addUserTask(data);
            }
        }      
      
      getUserForKey(userKey) {
          let user = null;
          if(this.users[userKey]) {
              user = this.users[userKey];
          }
          return user;
      }
      
      updateUserTask(data = null) {
          if(data?.userKey) {
              let user = {};
              if(this.users[data?.userKey]) {
                  user = {...this.users[data?.userKey]};
              }
              let dayKey = data?.day['daykey'];
              let scheduleDays = Object.keys(user);
          
            if(user[dayKey]) {
                if(parseInt(user[dayKey]["workhours"]) > 0) {
                    this.duration -=  parseInt(user[dayKey]["workhours"]);
                }
                this.duration += data.workhours;
                user[dayKey]["workhours"] = data.workhours;
            }
        }
      }
      
      addUserTask(data = null) {
          if(data?.dossier) {
              this.dossierKey = data?.dossier?.key;
          }
          if(data?.taskKey) {
              this.taskKey = data?.taskKey; 
          }
          if(data?.userKey) {
              this.userKey = data?.userKey;
               
              let dayKey = data?.day['daykey'];
              let userDayTask = new TaskUser();
              userDayTask.userKey = data?.userKey;
              userDayTask.dayKey = dayKey;
              userDayTask.workhours = 0;

                let user = {...this.users[data?.userKey], [userDayTask.dayKey]: userDayTask};
                
                if(this.users) {
                this.users = {...this.users, [data?.userKey]: user}
                } else {
                    this.users = {[data?.userKey]: user};    
                }

                if(!this.startDay && !this.endDay) {
                    this.startDay = data?.day;
                    this.endDay = data?.day;
                } else {
                    let currentDay = parseInt(dayKey);
                    let startDay = parseInt(this.startDay['daykey']);
                    let endDay = parseInt(this.endDay['daykey']);
                    if(currentDay < startDay) {
                        this.startDay = data?.day;
                    }
                    if(currentDay > endDay) {
                        this.endDay = data?.day;
                    }    

                }   
                
               
          }
      }
 
      
      public syncData(data:any) {
            if(data) {
                Object.keys(data).map((item) => {
                    if(item == 'users') {
                        
                        let userKeys = Object.keys(data.users);
                        if(userKeys.length > 0) {
                            Object.keys(data.users).map((itemKey, taskIndex) => {
                                let item = data.users[itemKey];
                                Object.keys(item).map((dayKeys) => {
                                    /*
                                  let userDayTask = new TaskUser();
                                  console.debug(  "!!!!!!userDayTaskuserDayTaskuserDayTaskuserDayTask", userDayTask )
                                  userDayTask.syncData(data.users[itemKey][dayKeys]);
                                    let user = {...this.users[itemKey], [dayKeys]: {...userDayTask} };                              
                                    if(this.users) {
                                        this.users = {...this.users, [itemKey]: {...user}}
                                    } else {
                                        this.users = {[itemKey]: {...user}};    
                                    } 
                                    */                             
                                });
                             });
                        } else {
                            this.users = null;
                        }
                    }
                    if(data[item]=== "object") {
                        this[item] = {...data[item]};
                    } else {
                        this[item] = data[item];
                    }
                });
            }
                            
            
      }
      
      
    }